import {
  FETCH_BOOKS_FAILURE,
  FETCH_BOOKS_SUCCESS,
  UPDATE_BOOK,
} from "./actionType";

export const fetchBooks =
  (isFeatured = false) =>
  async (dispatch) => {
    try {
      const response = await fetch(
        `http://localhost:9000/books?${isFeatured ? "featured=true" : ""}`
      );
      const data = await response.json();

      dispatch({
        type: FETCH_BOOKS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_BOOKS_FAILURE,
        payload: error.message,
      });
    }
  };

export const updateBook = (book) => {
  return {
    type: UPDATE_BOOK,
    payload: book,
  };
};
